import React from "react";
import "./styles.scss";

const Footer = (props) => {
  return (
    <footer className="footer text-center mt-5 mb-3">
      <p>Powered by <strong>Shobbu.com</strong></p>
    </footer>
  );
};

export default Footer;
